/* ============================================================
   HORSED Theme JS
   Converted from React (Framer Motion / React state) → Vanilla JS
   ============================================================ */

(function () {
  "use strict";

  /* ============================================================
     Utilities
     ============================================================ */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const on = (el, ev, fn, opts) => el?.addEventListener(ev, fn, opts);
  const off = (el, ev, fn) => el?.removeEventListener(ev, fn);

  function lockScroll() {
    document.body.style.overflow = "hidden";
  }
  function unlockScroll() {
    document.body.style.overflow = "";
  }

  /* ============================================================
     1. Scroll-Reveal  (replaces Framer Motion whileInView)
        Watches .scroll-reveal and .scroll-reveal-scale elements
     ============================================================ */
  function initScrollReveal() {
    const els = $$(".scroll-reveal, .scroll-reveal-scale");
    if (!els.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
    );

    els.forEach((el) => io.observe(el));
  }

  /* ============================================================
     2. Header
        - Fixed, transparent on homepage hero
        - Glassmorphism (is-solid) when scrolled > 50px
        - Also solid when mega menu is open
     ============================================================ */
  const header = $(".header");
  let isHomePage = document.body.classList.contains("template-index");
  let megaMenuOpen = false;

  function updateHeader() {
    if (!header) return;
    const scrolled = window.scrollY > 50;
    const isTransparentEnabled = header.dataset.transparent === "true";
    const solid =
      !isHomePage || !isTransparentEnabled || scrolled || megaMenuOpen;
    header.classList.toggle("is-solid", solid);
    header.classList.toggle("header--transparent", !solid);
  }

  function initHeader() {
    if (!header) return;
    updateHeader();
    on(window, "scroll", updateHeader, { passive: true });
  }

  /* Mega Menu is now handled purely via CSS/Liquid in header.liquid */

  /* ============================================================
     4. Mobile Navigation
     ============================================================ */
  function initMobileNav() {
    const toggle = $(".header__mobile-toggle");
    const nav = $(".mobile-nav");
    const close = $(".mobile-nav__close");
    const backdrop = $(".overlay-backdrop");

    function open() {
      nav?.classList.add("is-open");
      backdrop?.classList.add("is-visible");
      toggle?.setAttribute("aria-expanded", "true");
      lockScroll();
    }
    function close_() {
      nav?.classList.remove("is-open");
      backdrop?.classList.remove("is-visible");
      toggle?.setAttribute("aria-expanded", "false");
      unlockScroll();
    }

    on(toggle, "click", open);
    on(close, "click", close_);
    on(backdrop, "click", close_);

    // Mobile sub-category toggles (chevron button only — title link navigates directly)
    $$(".mobile-nav__chevron-btn").forEach((btn) => {
      on(btn, "click", () => {
        const row = btn.closest(".mobile-nav__toggle-row");
        const sub = row?.nextElementSibling;
        const icon = btn.querySelector(".mobile-nav__chevron");
        const isOpen = sub?.classList.contains("is-open");

        // Close others
        $$(".mobile-nav__sub.is-open").forEach((s) =>
          s.classList.remove("is-open"),
        );
        $$(".mobile-nav__chevron.is-open").forEach((i) =>
          i.classList.remove("is-open"),
        );

        if (!isOpen) {
          sub?.classList.add("is-open");
          icon?.classList.add("is-open");
        }
      });
    });

    on(document, "keydown", (e) => {
      if (e.key === "Escape") close_();
    });
  }

  /* ============================================================
     5. Search Drawer  (replaces AnimatePresence slide-from-top)
     ============================================================ */
  function initSearchDrawer() {
    const drawer = $(".search-drawer");
    const backdrop = $(".search-drawer-backdrop");
    const openBtns = $$("[data-open-search]");
    const closeBtns = $$("[data-close-search]");
    const input = $(".search-drawer__input");
    const clearBtn = $(".search-drawer__clear");

    if (!drawer) return;

    let recentSearches = [];
    try {
      recentSearches = JSON.parse(
        localStorage.getItem("horsed_recent_searches") || "[]",
      );
    } catch (e) {}

    function openSearch() {
      drawer.classList.add("is-open");
      backdrop?.classList.add("is-visible");
      lockScroll();
      setTimeout(() => input?.focus(), 80);
      renderSuggestions();
    }

    function closeSearch() {
      drawer.classList.remove("is-open");
      backdrop?.classList.remove("is-visible");
      unlockScroll();
      if (input) input.value = "";
      renderSuggestions();
    }

    openBtns.forEach((btn) => on(btn, "click", openSearch));
    closeBtns.forEach((btn) => on(btn, "click", closeSearch));
    on(backdrop, "click", closeSearch);
    on(document, "keydown", (e) => {
      if (e.key === "Escape") closeSearch();
    });

    // Clear button
    on(clearBtn, "click", () => {
      if (input) input.value = "";
      renderSuggestions();
    });

    // Live search
    on(
      input,
      "input",
      debounce(() => {
        const q = input?.value.trim();
        if (q) {
          fetchSearchResults(q);
        } else {
          renderSuggestions();
        }
      }, 300),
    );

    on(input, "keydown", (e) => {
      if (e.key === "Enter" && input.value.trim()) {
        saveSearch(input.value.trim());
        window.location.href = `${window.routes?.predictive_search_url?.replace("predictive_search", "search") || "/search"}?q=${encodeURIComponent(input.value.trim())}`;
      }
    });

    function saveSearch(term) {
      recentSearches = [
        term,
        ...recentSearches.filter((s) => s !== term),
      ].slice(0, 5);
      localStorage.setItem(
        "horsed_recent_searches",
        JSON.stringify(recentSearches),
      );
    }

    function renderSuggestions() {
      const body = drawer.querySelector(".search-drawer__body");
      if (!body) return;

      const popularSearches = [
        "Competition Jacket",
        "Leather Boots",
        "Riding Gloves",
        "Show Shirt",
        "Bridle",
      ];
      const trendingCats = [
        "Competition Wear",
        "Footwear",
        "Accessories",
        "Tack & Equipment",
      ];

      const recentHtml = recentSearches.length
        ? `
        <div>
          <div class="search-drawer__group-head">
            <span class="search-drawer__group-title"><svg class="search-drawer__group-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>Recent</span>
            <button class="search-drawer__clear-btn" data-clear-recent>Clear</button>
          </div>
          <ul class="search-drawer__list list-unstyled">
            ${recentSearches.map((s) => `<li><button class="search-drawer__item" data-quick-search="${s}"><span class="search-drawer__item-text">${s}</span><span class="search-drawer__item-arrow">→</span></button></li>`).join("")}
          </ul>
        </div>`
        : "";

      const popularHtml = `
        <div>
          <div class="search-drawer__group-title"><svg class="search-drawer__group-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>Popular</div>
          <ul class="search-drawer__list list-unstyled">
            ${popularSearches.map((s) => `<li><button class="search-drawer__item" data-quick-search="${s}"><span class="search-drawer__item-text">${s}</span><span class="search-drawer__item-arrow">→</span></button></li>`).join("")}
          </ul>
        </div>`;

      const catsHtml = `
        <div class="search-drawer__categories">
          <div class="search-drawer__group-title">Explore Categories</div>
          <div class="search-drawer__cat-grid">
            ${trendingCats
              .map(
                (c) =>
                  `<a href="/collections/${c
                    .toLowerCase()
                    .replace(/\s+&\s+/g, "-")
                    .replace(
                      /\s+/g,
                      "-",
                    )}" class="search-drawer__cat-link">${c}</a>`,
              )
              .join("")}
          </div>
        </div>`;

      body.innerHTML = `<div class="search-drawer__suggestions">${recentHtml}${popularHtml}${catsHtml}</div>`;

      // Wire quick-search buttons
      body.querySelectorAll("[data-quick-search]").forEach((btn) => {
        on(btn, "click", () => {
          if (input) input.value = btn.dataset.quickSearch;
          input?.focus();
          fetchSearchResults(btn.dataset.quickSearch);
        });
      });

      // Wire clear recent
      const clearRecent = body.querySelector("[data-clear-recent]");
      on(clearRecent, "click", () => {
        recentSearches = [];
        localStorage.removeItem("horsed_recent_searches");
        renderSuggestions();
      });
    }

    function fetchSearchResults(q) {
      const body = drawer.querySelector(".search-drawer__body");
      if (!body) return;

      const url = `${window.routes?.predictive_search_url || "/search/suggest"}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;

      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          // Parse and render results from Shopify Predictive Search API
          body.innerHTML = `<p class="search-drawer__count">Showing results for "${q}"</p><div class="search-results-grid">${html}</div>`;
        })
        .catch(() => {
          // Fallback: just link to search page
          body.innerHTML = `<p class="search-drawer__count">Press Enter to search for "${q}"</p>`;
        });
    }

    renderSuggestions();
  }

  /* ============================================================
     6. Cart Drawer  (replaces Sheet component, uses Shopify Cart API)
     ============================================================ */
  function initCartDrawer() {
    const drawer = $(".cart-drawer");
    const backdrop = $(".overlay-backdrop");
    const openBtns = $$("[data-open-cart]");
    const closeBtns = $$("[data-close-cart]");

    if (!drawer) return;

    function openCart() {
      refreshCart().then(() => {
        drawer.classList.add("is-open");
        backdrop?.classList.add("is-visible");
        lockScroll();
      });
    }

    function closeCart() {
      drawer.classList.remove("is-open");
      backdrop?.classList.remove("is-visible");
      unlockScroll();
    }

    openBtns.forEach((btn) => on(btn, "click", openCart));
    closeBtns.forEach((btn) => on(btn, "click", closeCart));
    on(backdrop, "click", (e) => {
      // Only close if we actually click the backdrop itself
      if (e.target === backdrop) {
        closeCart();
      }
    });

    on(document, "keydown", (e) => {
      if (e.key === "Escape") closeCart();
    });

    // Qty buttons inside drawer
    on(drawer, "click", (e) => {
      const qtyUp = e.target.closest("[data-qty-up]");
      const qtyDown = e.target.closest("[data-qty-down]");
      const remove = e.target.closest("[data-remove-item]");

      if (qtyUp)
        updateCartItem(qtyUp.dataset.qtyUp, parseInt(qtyUp.dataset.qty) + 1);
      if (qtyDown)
        updateCartItem(
          qtyDown.dataset.qtyDown,
          parseInt(qtyDown.dataset.qty) - 1,
        );
      if (remove) updateCartItem(remove.dataset.removeItem, 0);
    });

    function updateCartItem(key, qty) {
      fetch(window.routes?.cart_change_url || "/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty }),
      })
        .then((r) => r.json())
        .then(() => refreshCart());
    }

    function refreshCart() {
      return fetch("/cart.js")
        .then((r) => r.json())
        .then((cart) => renderCart(cart))
        .catch(() => {});
    }

    function renderCart(cart) {
      const body = drawer.querySelector(".cart-drawer__body");
      const footer = drawer.querySelector(".cart-drawer__footer");
      const countEls = $$("[data-cart-count]");

      // Update header count
      countEls.forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? "" : "none";
      });

      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = `<div class="cart-drawer__empty">Your bag is empty</div>`;
        if (footer) footer.style.display = "none";
        return;
      }

      body.innerHTML = `<div class="cart-drawer__items">
        ${cart.items
          .map(
            (item) => `
          <div class="cart-drawer-item">
            <div class="cart-drawer-item__img">
              <img src="${item.image}" alt="${item.product_title}" loading="lazy">
            </div>
            <div class="cart-drawer-item__info">
              <div class="cart-drawer-item__top">
                <div>
                  <p class="cart-drawer-item__name">${item.product_title}</p>
                  <p class="cart-drawer-item__category">${item.variant_title !== "Default Title" ? item.variant_title : ""}</p>
                </div>
                <button class="cart-drawer-item__remove" data-remove-item="${item.key}" aria-label="Remove">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>
              <div class="cart-drawer-item__bottom">
                <div class="cart-qty">
                  <button class="cart-qty__btn" data-qty-down="${item.key}" data-qty="${item.quantity}">−</button>
                  <span class="cart-qty__num">${item.quantity}</span>
                  <button class="cart-qty__btn" data-qty-up="${item.key}" data-qty="${item.quantity}">+</button>
                </div>
                <p class="cart-drawer-item__price">${formatMoney(item.line_price)}</p>
              </div>
            </div>
          </div>`,
          )
          .join("")}
      </div>`;

      if (footer) {
        footer.style.display = "";
        const totalEl = footer.querySelector(".cart-drawer__subtotal-value");
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      }
    }

    // Initial render
    refreshCart();
  }

  /* ============================================================
     7. Add to Cart (product cards & product page)
     ============================================================ */
  function initAddToCart() {
    on(document, "click", (e) => {
      const btn = e.target.closest("[data-atc]");
      if (!btn || btn.disabled) return;
      e.preventDefault();

      const variantId = btn.dataset.atc;
      if (!variantId) return;

      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = "Adding…";

      fetch(window.routes?.cart_add_url || "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((r) => r.json())
        .then(() => {
          btn.textContent = "Added!";
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
          // Refresh cart drawer count
          fetch("/cart.js")
            .then((r) => r.json())
            .then((cart) => {
              $$("[data-cart-count]").forEach((el) => {
                el.textContent = cart.item_count;
                el.style.display = cart.item_count > 0 ? "" : "none";
              });
            });
        })
        .catch(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  }

  /* ============================================================
     8. FAQ Accordion  (replaces Framer Motion animate height)
     ============================================================ */
  function initFAQ() {
    $$(".faq-item__toggle").forEach((toggle) => {
      on(toggle, "click", () => {
        const answer = toggle.nextElementSibling;
        const icon = toggle.querySelector(".faq-item__icon");
        const isOpen = answer?.classList.contains("is-open");

        // Close all
        $$(".faq-item__answer.is-open").forEach((a) =>
          a.classList.remove("is-open"),
        );
        $$(".faq-item__icon.is-open").forEach((i) =>
          i.classList.remove("is-open"),
        );

        if (!isOpen) {
          answer?.classList.add("is-open");
          icon?.classList.add("is-open");
        }
      });
    });
  }

  /* ============================================================
     9. Quantity Selectors (product page)
     ============================================================ */
  function initQuantity() {
    $$(".quantity").forEach((wrap) => {
      const input = wrap.querySelector(".quantity__input");
      on(wrap.querySelector(".quantity__btn--minus"), "click", () => {
        const val = parseInt(input?.value || "1", 10);
        const min = parseInt(input?.min || "1", 10);
        if (val > min) {
          input.value = val - 1;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
      on(wrap.querySelector(".quantity__btn--plus"), "click", () => {
        const val = parseInt(input?.value || "1", 10);
        input.value = val + 1;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }

  /* ============================================================
     10. Product Page Gallery
     ============================================================ */
  function initProductGallery() {
    const thumbs = $$(".product-page__thumb");
    const mainImg = $(".product-page__main-img img");

    thumbs.forEach((thumb) => {
      on(thumb, "click", () => {
        thumbs.forEach((t) =>
          t.classList.remove("product-page__thumb--active"),
        );
        thumb.classList.add("product-page__thumb--active");
        if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
      });
    });
  }

  /* ============================================================
     11. Product Page Variant Selection
     ============================================================ */
  function initVariants() {
    const form = $(".product-form--page");
    if (!form || !window.__productVariants) return;

    const selects = $$('select[name^="options"]', form);
    const submitBtn = form.querySelector("[data-atc]");
    const priceEl = form.querySelector("[data-product-price]");

    selects.forEach((s) => on(s, "change", matchVariant));

    function matchVariant() {
      const values = selects.map((s) => s.value);
      const variant = window.__productVariants.find((v) =>
        v.options.every((opt, i) => opt === values[i]),
      );
      if (!variant) return;

      if (submitBtn) {
        submitBtn.dataset.atc = variant.id;
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? "Add to Bag" : "Sold Out";
      }
      if (priceEl && variant.price)
        priceEl.textContent = formatMoney(variant.price);
    }
  }

  /* ============================================================
     12. Cart Page qty auto-submit
     ============================================================ */
  function initCartPage() {
    const form = $("#cart-form");
    if (!form) return;
    $$(".quantity__input", form).forEach((input) => {
      on(
        input,
        "change",
        debounce(() => form.submit(), 400),
      );
    });
  }

  /* ============================================================
     13. Newsletter form
     ============================================================ */
  function initNewsletter() {
    $$(".newsletter__form").forEach((form) => {
      const success = form.nextElementSibling;
      // Shopify handles the form submission via customer form
      // Just handle the client-side success state
      on(form, "submit", () => {
        setTimeout(() => {
          const successEl = form.parentNode.querySelector(
            ".newsletter__success",
          );
          if (successEl) successEl.style.display = "block";
        }, 500);
      });
    });
  }

  /* ============================================================
     Helpers
     ============================================================ */
  function formatMoney(cents) {
    const sym =
      window.Shopify?.currency?.active === "GBP"
        ? "£"
        : window.Shopify?.currency?.active === "EUR"
          ? "€"
          : "$";
    return sym + (cents / 100).toFixed(2);
  }

  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }

  /* ============================================================
     13. Sort Dropdown (custom luxury replacement for <select>)
     ============================================================ */
  function initSortDropdown() {
    const dropdown = $("#sort-dropdown");
    if (!dropdown) return;

    const trigger = dropdown.querySelector(".sort-dropdown__trigger");
    const panel = dropdown.querySelector(".sort-dropdown__panel");
    const currentLabel = dropdown.querySelector(".sort-dropdown__current");
    const hiddenSelect = $("#SortBy");

    if (!trigger || !panel || !hiddenSelect) return;

    function openPanel() {
      panel.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
    }
    function closePanel() {
      panel.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
    }

    on(trigger, "click", (e) => {
      e.stopPropagation();
      panel.classList.contains("is-open") ? closePanel() : openPanel();
    });

    on(document, "click", (e) => {
      if (!dropdown.contains(e.target)) closePanel();
    });

    on(document, "keydown", (e) => {
      if (e.key === "Escape") closePanel();
    });

    $$(".sort-dropdown__option", panel).forEach((opt) => {
      on(opt, "click", () => {
        const val = opt.dataset.sortValue;
        hiddenSelect.value = val;
        if (currentLabel) currentLabel.textContent = opt.textContent.replace(/✓/g, "").trim();
        // Update active state
        $$(".sort-dropdown__option", panel).forEach((o) => {
          o.classList.toggle("is-active", o === opt);
          o.setAttribute("aria-selected", String(o === opt));
          const check = o.querySelector("svg");
          if (check) check.remove();
          if (o === opt) {
            o.insertAdjacentHTML("beforeend", `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>`);
          }
        });
        closePanel();
        hiddenSelect.dispatchEvent(new Event("change", { bubbles: true }));
        hiddenSelect.closest("form")?.submit();
      });
    });
  }

  /* ============================================================
     13b. Filter Dropdowns (size filter: trigger + panel of checkboxes)
     ============================================================ */
  function initFilterDropdowns() {
    $$(".filter-size-dropdown").forEach((dropdown) => {
      const trigger = dropdown.querySelector(".filter-size-dropdown__trigger");
      const panel = dropdown.querySelector(".filter-size-dropdown__panel");
      if (!trigger || !panel) return;

      function openPanel() {
        panel.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
      }
      function closePanel() {
        panel.classList.remove("is-open");
        trigger.setAttribute("aria-expanded", "false");
      }

      on(trigger, "click", (e) => {
        e.stopPropagation();
        panel.classList.contains("is-open") ? closePanel() : openPanel();
      });

      on(document, "click", (e) => {
        if (!dropdown.contains(e.target)) closePanel();
      });

      on(document, "keydown", (e) => {
        if (e.key === "Escape") closePanel();
      });
    });
  }

  /* ============================================================
     14. Wishlist (localStorage-based)
     ============================================================ */
  function initWishlist() {
    const STORAGE_KEY = "horsed_wishlist";

    function getWishlist() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); }
      catch (e) { return []; }
    }
    function saveWishlist(ids) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    }
    function isWished(id) {
      return getWishlist().includes(String(id));
    }
    function toggleWish(id) {
      const list = getWishlist();
      const idx = list.indexOf(String(id));
      if (idx === -1) list.push(String(id));
      else list.splice(idx, 1);
      saveWishlist(list);
      return idx === -1;
    }

    function applyWishState(btn) {
      const id = btn.dataset.productId;
      if (!id) return;
      const wished = isWished(id);
      btn.classList.toggle("is-wished", wished);
      const icon = btn.querySelector(".product-card__wishlist-icon, .btn-wishlist-icon");
      if (icon) {
        icon.setAttribute("fill", wished ? "currentColor" : "none");
        icon.style.color = wished ? "var(--color-rose)" : "";
      }
      btn.setAttribute("aria-label", wished
        ? `Remove ${btn.dataset.productTitle || ""} from wishlist`
        : `Add ${btn.dataset.productTitle || ""} to wishlist`);
    }

    // Apply saved state on page load
    $$("[data-product-id]").forEach((btn) => {
      if (btn.classList.contains("product-card__wishlist") || btn.classList.contains("btn-wishlist")) {
        applyWishState(btn);
      }
    });

    // Toggle on click
    on(document, "click", (e) => {
      const btn = e.target.closest(".product-card__wishlist, .btn-wishlist");
      if (!btn) return;
      e.preventDefault();
      const id = btn.dataset.productId;
      if (!id) return;
      toggleWish(id);
      applyWishState(btn);

      // Pulse animation
      btn.classList.add("wish-pulse");
      setTimeout(() => btn.classList.remove("wish-pulse"), 400);
    });
  }

  /* ============================================================
     Init
     ============================================================ */
  document.addEventListener("DOMContentLoaded", () => {
    initScrollReveal();
    initHeader();
    initMobileNav();
    initSearchDrawer();
    initCartDrawer();
    initAddToCart();
    initFAQ();
    initQuantity();
    initProductGallery();
    initVariants();
    initCartPage();
    initNewsletter();
    initSortDropdown();
    initFilterDropdowns();
    initWishlist();
  });
})();
